import { mapState } from 'vuex';

export default {
  data: () => ({
    knownRoles: new Map([
      [1, 'admin'],
      [3, 'manager'],
      [6, 'super'],
      [8, 'antifraud'],
      [9, 'typist'],
      [10, 'financial'],
      [11, 'commercial'],
      [12, 'consultant'],
      [13, 'creditor'],
      [14, 'compliance'],
      [15, 'tenant'],
      [16, 'coordenador'],
      [17, 'superintendent'],
      [18, 'master'],
      [20, 'accessManager'],
      [23, 'managerMaster'],
      [24, 'collector'],
    ]),
  }),
  computed: {
    ...mapState({
      roles: (state) => {
        if (state.user.userInfo && state.user.userInfo.roles_ids) {
          return state.user.userInfo.roles_ids;
        }
        return [];
      },
    }),
    isAdmin() { return this.roles.includes(1); },
    isManager() { return this.roles.includes(3); },
    isSuper() { return this.roles.includes(6); },
    isAntifraud() { return this.roles.includes(8); },
    isTypist() { return this.roles.includes(9); },
    isMasterOrFinancial() { return this.roles.includes(10) || this.roles.includes(18); },
    isCommercial() { return this.roles.includes(11); },
    isConsultant() { return this.roles.includes(12); },
    isCreditor() { return this.roles.includes(13); },
    isCompliance() { return this.roles.includes(14); },
    isTenant() { return this.roles.includes(15); },
    isCoordenador() { return this.roles.includes(16); },
    isSuperIntendent() { return this.roles.includes(17); },
    isAccessManager() { return this.roles.includes(20); },
    isManagerMaster() { return this.roles.includes(23); },
    isMaster() { return this.roles.includes(18); },
    isCollector() { return this.roles.includes(24); },
    canManageBlacklist() { return this.isSuper || this.isAdmin; },
    canDeactivateUsers() {
      return this.isSuper || this.isAdmin || this.isCommercial || this.isSuperIntendent;
    },
    canManageInvoices() { return this.isSuper || this.isAdmin || this.isCommercial; },
    canViewInvoiceFollowUp() { return this.canManageInvoices || this.isAntifraud; },
    // PUT /status is restricted to these; commercial and promoter finance only read.
    canReviewInvoices() { return this.isSuper || this.isAdmin; },
    // B2B-185: perfil Master/Admin da promotora — confirmar com backend/produto
    // se "Admin" da promotora tem role_id próprio ou equivale a master(18)/managerMaster(23).
    isPromotoraMasterOrAdmin() {
      return [this.isAdmin, this.isMaster, this.isManagerMaster].some((isValid) => isValid);
    },
  },
};
